import { useTranslation } from "react-i18next";import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

const STATS = [
{ value: '12,400+', label: 'Units managed' },
{ value: '98%', label: 'On-time payments' },
{ value: '500+', label: 'Property managers' }];


export default function Hero() {const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const [loaded, setLoaded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    // Tiny delay so the CSS transition actually runs
    const t = setTimeout(() => setLoaded(true), 80);

    const vid = videoRef.current;
    if (!vid) return () => clearTimeout(t);

    const tryPlay = () => vid.play().catch(() => {});
    vid.addEventListener('loadedmetadata', tryPlay);
    vid.addEventListener('canplay', tryPlay);
    tryPlay();

    const unlockOnInteraction = () => {
      vid.play().catch(() => {});
      document.removeEventListener('click', unlockOnInteraction);
      document.removeEventListener('touchstart', unlockOnInteraction);
    };
    document.addEventListener('click', unlockOnInteraction);
    document.addEventListener('touchstart', unlockOnInteraction);

    return () => {
      clearTimeout(t);
      vid.removeEventListener('loadedmetadata', tryPlay);
      vid.removeEventListener('canplay', tryPlay);
      document.removeEventListener('click', unlockOnInteraction);
      document.removeEventListener('touchstart', unlockOnInteraction);
    };
  }, []);

  return (
    <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Inter:wght@300;400;500&display=swap');

        /* ── Typefaces ─────────────────────────────────── */
        .h-serif        { font-family: 'Instrument Serif', Georgia, serif; font-weight: 400; }
        .h-serif-italic { font-family: 'Instrument Serif', Georgia, serif; font-weight: 400; font-style: italic; }

        /* ── Grain overlay ─────────────────────────────── */
        .h-grain {
          position: absolute; inset: 0; z-index: 3; pointer-events: none;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='1'/%3E%3C/svg%3E");
          opacity: 0.035;
          mix-blend-mode: overlay;
        }

        /* ── Reveal animation ──────────────────────────── */
        .h-in {
          opacity: 0;
          transform: translateY(22px);
          transition: opacity 1s cubic-bezier(0.16,1,0.3,1),
                      transform 1s cubic-bezier(0.16,1,0.3,1);
        }
        .h-in.on { opacity: 1; transform: translateY(0); }

        /* ── CTA buttons ───────────────────────────────── */
        .h-btn-primary {
          display: inline-flex; align-items: center; gap: 10px;
          background: #c41e1e;
          color: #fff;
          font-size: 13.5px; font-weight: 500; letter-spacing: 0.2px;
          padding: 13px 28px; border-radius: 100px;
          transition: background 0.25s, box-shadow 0.25s, transform 0.2s;
          text-decoration: none;
        }
        .h-btn-primary:hover {
          background: #a91818;
          box-shadow: 0 0 36px rgba(196,30,30,0.45);
          transform: translateY(-1px);
        }

        .h-btn-ghost {
          display: inline-flex; align-items: center; gap: 8px;
          color: rgba(255,255,255,0.5);
          font-size: 13.5px; font-weight: 400; letter-spacing: 0.2px;
          padding: 13px 28px; border-radius: 100px;
          border: 1px solid rgba(255,255,255,0.10);
          background: transparent;
          transition: color 0.25s, border-color 0.25s, background 0.25s, transform 0.2s;
          text-decoration: none;
        }
        .h-btn-ghost:hover {
          color: rgba(255,255,255,0.85);
          border-color: rgba(255,255,255,0.22);
          background: rgba(255,255,255,0.04);
          transform: translateY(-1px);
        }

        /* ── Scroll indicator ─────────────────────────── */
        @keyframes h-scroll-pulse {
          0%, 100% { opacity: 0.18; transform: scaleY(1); }
          50%       { opacity: 0.45; transform: scaleY(0.6); }
        }
        .h-scroll-line {
          animation: h-scroll-pulse 2.4s ease-in-out infinite;
        }

        /* ── CTA buttons refined ───────────────────────── */
        .h-btn-primary {
          display: inline-flex; align-items: center; gap: 10px;
          background: linear-gradient(135deg, #c41e1e 0%, #9e1414 100%);
          color: #fff;
          font-size: 13px; font-weight: 500; letter-spacing: 0.3px;
          padding: 12px 26px; border-radius: 100px;
          border: 1px solid rgba(255,120,120,0.15);
          transition: opacity 0.22s, box-shadow 0.22s, transform 0.18s;
          text-decoration: none;
        }
        .h-btn-primary:hover {
          opacity: 0.88;
          box-shadow: 0 4px 32px rgba(180,20,20,0.5);
          transform: translateY(-1px);
        }

        .h-btn-ghost {
          display: inline-flex; align-items: center; gap: 8px;
          color: ${isDarkMode ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,0.55)'};
          font-size: 13px; font-weight: 400; letter-spacing: 0.3px;
          padding: 12px 26px; border-radius: 100px;
          border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.09)' : 'rgba(0,0,0,0.12)'};
          background: ${isDarkMode ? 'rgba(255,255,255,0.025)' : 'rgba(0,0,0,0.02)'};
          backdrop-filter: blur(10px);
          transition: color 0.22s, border-color 0.22s, background 0.22s, transform 0.18s;
          text-decoration: none;
        }
        .h-btn-ghost:hover {
          color: rgba(255,255,255,0.82);
          border-color: rgba(255,255,255,0.18);
          background: rgba(255,255,255,0.05);
          transform: translateY(-1px);
        }

        /* ── Stat divider ──────────────────────────────── */
        .h-stat-div {
          width: 1px; height: 28px;
          background: linear-gradient(to bottom, transparent, ${isDarkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.1)'}, transparent);
        }
      `}</style>

            <section id="home" className="relative w-full min-h-screen overflow-hidden flex flex-col">

                {/* ── Background video ─────────────────────────────── */}
                <div
          className="absolute inset-0 z-0 overflow-hidden"
          style={{ WebkitTransform: 'translateZ(0)', transform: 'translateZ(0)' }}>
          
                    <video
            ref={videoRef}
            autoPlay muted loop playsInline
            webkit-playsinline="true"
            preload="auto"
            className="w-full h-full object-cover"
            style={{ display: 'block' }}>
            
                        <source src="/assets/hero-silent.mp4" type="video/mp4" />
                    </video>
                </div>

                {/* ── Overlays ─────────────────────────────────────── */}
                {/* Base darkening/lightening overlay */}
                <div
          className="absolute inset-0 z-[1]"
          style={{
            background: isDarkMode ?
            'rgba(0,0,0,0.55)' :
            'rgba(255,255,255,0.4)',
            transition: 'background 0.3s ease'
          }} />
        

                {/* Cinematic vignette — subtle at top, heavier at bottom */}
                <div className="absolute inset-0 z-[2]" style={{
          background: isDarkMode ?
          'linear-gradient(160deg, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.0) 40%, rgba(0,0,0,0.88) 100%)' :
          'linear-gradient(160deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.0) 60%, rgba(255,255,255,0.5) 100%)',
          transition: 'background 0.3s ease'
        }} />

                {/* Bottom-up fade to solid — Removed in light mode as requested */}
                <div className="absolute inset-0 z-[2]" style={{
          background: isDarkMode ?
          'linear-gradient(to top, #09090b 0%, rgba(9,9,11,0.7) 22%, transparent 55%)' :
          'transparent',
          transition: 'background 0.3s ease'
        }} />
                {/* Subtle red warmth bottom-left */}
                <div className="absolute bottom-0 left-0 w-full max-w-[600px] h-[360px] z-[2] pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at bottom left, rgba(140,18,8,0.18) 0%, transparent 68%)', filter: 'blur(60px)' }} />
        
                {/* Grain */}
                <div className="h-grain" />

                {/* ── Main content ─────────────────────────────────── */}
                <div className="relative z-10 flex flex-col justify-end flex-1 px-5 sm:px-8 md:px-16 pb-16 sm:pb-20 md:pb-28 pt-28 sm:pt-36">

                    {/* Eyebrow */}
                    <div
            className={`h-in ${loaded ? 'on' : ''} mb-8`}
            style={{ transitionDelay: '0s' }}>
            
                        <span className="inline-flex items-center gap-2.5" style={{ fontSize: 11, fontWeight: 500, color: isDarkMode ? 'rgba(255,255,255,0.7)' : '#000', letterSpacing: '2.5px', textTransform: 'uppercase' }}>
                            <span style={{ display: 'inline-block', width: 20, height: 1, background: '#c41e1e', flexShrink: 0 }} />
                            {t("quadcores_properties_1")}
                            <span style={{ display: 'inline-block', width: 20, height: 1, background: isDarkMode ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.2)', flexShrink: 0 }} />
                        </span>
                    </div>

                    {/* Headline */}
                    <h1
            className={`h-serif h-in ${loaded ? 'on' : ''} ${isDarkMode ? 'text-white' : 'text-zinc-900'} mb-3`}
            style={{
              fontSize: 'clamp(2.4rem, 7.5vw, 8rem)',
              lineHeight: 0.95,
              letterSpacing: '-2px',
              transitionDelay: '0.1s',
              maxWidth: 820
            }}>
                        {t("every_property")}
                    
          </h1>
                    <h1
            className={`h-serif-italic h-in ${loaded ? 'on' : ''} mb-10`}
            style={{
              fontSize: 'clamp(2.4rem, 7.5vw, 8rem)',
              lineHeight: 0.95,
              letterSpacing: '-2px',
              transitionDelay: '0.18s',
              maxWidth: 820,
              color: isDarkMode ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.7)'
            }}>
                        {t("under_control")}
                    
          </h1>

                    {/* Sub-copy */}
                    <p
            className={`h-in ${loaded ? 'on' : ''} mb-12`}
            style={{
              transitionDelay: '0.3s',
              maxWidth: 420,
              fontSize: 15,
              fontWeight: 300,
              lineHeight: 1.75,
              color: isDarkMode ? 'rgba(255,255,255,0.75)' : '#000',
              letterSpacing: '0.1px'
            }}>
                        {t("one_platform_for_leases_rent_collection")}
                    

          </p>

                    {/* CTAs */}
                    <div
            className={`h-in ${loaded ? 'on' : ''} flex flex-wrap items-center gap-3 mb-16`}
            style={{ transitionDelay: '0.42s' }}>
            
                        <Link to="/register" className="h-btn-primary">
                            {t("start_free_trial_1")}
                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" style={{ opacity: 0.75 }}>
                                <path d="M2 6.5h9M7.5 2.5l4 4-4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Link>
                        <Link to="/portal/tenant/login" className="h-btn-ghost">
                            {t("view_dashboard")}
                        </Link>
                    </div>

                    {/* Stats row */}
                    <div
            className={`h-in ${loaded ? 'on' : ''} flex flex-wrap items-center gap-6 md:gap-12`}
            style={{ transitionDelay: '0.56s' }}>
            
                        {STATS.map((s, i) =>
            <React.Fragment key={s.label}>
                                {i > 0 && <div className="h-stat-div" />}
                                <div>
                                    <div style={{ fontSize: 22, fontWeight: 600, color: isDarkMode ? '#fff' : '#000', letterSpacing: '-0.5px', lineHeight: 1 }}>
                                        {s.value}
                                    </div>
                                    <div style={{ fontSize: 11.5, fontWeight: 400, color: isDarkMode ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.95)', marginTop: 4, letterSpacing: '0.2px' }}>
                                        {s.label}
                                    </div>
                                </div>
                            </React.Fragment>
            )}
                    </div>
                </div>

                {/* ── Scroll indicator — hidden on mobile ───────────── */}
                <div
          className={`hidden sm:flex absolute bottom-9 right-10 z-10 flex-col items-center gap-2.5 h-in ${loaded ? 'on' : ''}`}
          style={{ transitionDelay: '0.9s' }}>
          
                    <span style={{
            fontSize: 9,
            color: isDarkMode ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.7)',
            letterSpacing: '3.5px',
            textTransform: 'uppercase',
            writingMode: 'vertical-rl',
            fontWeight: 400
          }}>
                        {t("scroll")}
                    </span>
                    <div
            className="h-scroll-line"
            style={{ width: 1, height: 48, background: `linear-gradient(to bottom, ${isDarkMode ? 'rgba(255,255,255,0.22)' : 'rgba(0,0,0,0.45)'}, transparent)` }} />
          
                </div>

            </section>
        </>);

}